import styled from "styled-components";
import {LiveCasinoFilterButtonLabelDefaultBox} from "./live-casino-filter-button-label.default.box";
import {ACTIVE} from "../../../../../../themes/css-global-classes";

export const LiveCasinoFilterButtonLabelMrGreenBox = styled(LiveCasinoFilterButtonLabelDefaultBox)`
    &.${ACTIVE} {
        color: ${({theme}) => theme.colors.brandSecondaryLight};
    }
`;
